import {
  BreadcrumbItem,
  BreadcrumbItemProps,
} from "@/components/navigations/Breadcrumb/BreadcrumbItem.tsx";
import clsx from "clsx";
import "./Breadcrumb.scss";

export type BreadcrumbProps = {
  items: BreadcrumbItemProps[];
};

export const Breadcrumb = ({
  items = [{ label: "Home", href: "#" }],
}: BreadcrumbProps) => {
  return (
    <nav aria-label="Percorso di navigazione">
      <ol className={clsx("ui-breadcrumb", "fs-6 md-fs-custom")}>
        {items.map((item, index) => (
          <li key={index} className="ui-breadcrumb-wrapper">
            <BreadcrumbItem
              label={item.label}
              href={item.href}
              asLink={item.asLink}
              isClickable={item.isClickable ?? true}
            />
            {index < items.length - 1 && (
              <span
                className={clsx(
                  "ui-breadcrumb-separator",
                  "fw-bold text-slate-28",
                )}
                aria-hidden="true"
              >
                /
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
